export default __webpack_public_path__ + "static/media/hardcore.1be9037d.jpg";